import { h } from 'preact'
import PropTypes from 'prop-types'

export default function TextArea({
  label,
  inputProps,
  hasError,
  errorMessage = '',
}) {
  return (
    <label className="input input-text">
      <span className="label">{label}</span>
      <div className="group">
        <textarea rows="4" {...inputProps} />
      </div>
      {hasError && (
        <p className="message" data-testid="error-message">
          {errorMessage}
        </p>
      )}
    </label>
  )
}

TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  inputProps: PropTypes.object.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
}
